import { useAuth } from 'src/provider/AuthProvider';
import { Banner } from './Banner';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { LimitReachedPopup } from './LimitReachedPopup/LimitReachedPopup';
import { useAppSelector } from 'src/store';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { COSSUPORT_DEMO_PAGE } from 'src/shared/constants';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { useEffect, useRef } from 'react';
import { ResendVerificationEmailButton } from 'src/components/HeaderBanner/ResendVerificationEmailButton/ResendVerificationEmailButton';

export function HeaderBanner() {
  const auth = useAuth();
  const bannerRef = useRef(null);

  const { storageTrialLimitOpen } = useAppSelector((s) => s.limitBannerSlices);
  const { data: account } = useGetAccountsQuery({}, { skip: !auth.user }) as any;
  const { data: userInfo } = useGetUsersMeQuery(undefined, { skip: !auth.user });
  const { isInactivePlan, isTrialPlan } = useAppSelector((s) => s.planSlice);
  const isPlanRequestLimit = account?.general_plan?.request_limit === 0;

  useEffect(() => {
    return () => {
      document.body.style.removeProperty('padding-top');
    };
  }, []);

  useEffect(() => {
    if (bannerRef.current) {
      const height = bannerRef.current.getBoundingClientRect().height || 0;

      document.body.style.paddingTop = `${height}px`;
    }
  }, [userInfo, isTrialPlan, isPlanRequestLimit, isInactivePlan, storageTrialLimitOpen]);

  return (
    auth.user && (
      <div ref={bannerRef} className={'fixed top-0 w-full z-50'}>
        {isTrialPlan && !isInactivePlan && isPlanRequestLimit && !storageTrialLimitOpen && (
          <Banner
            text={
              <>
                All free AI responses have been used. Fill out{' '}
                <a
                  target="_blank"
                  href={COSSUPORT_DEMO_PAGE}
                  className="underline"
                  rel="noopener noreferrer"
                >
                  <i>
                    <b>this form</b>
                  </i>
                </a>{' '}
                to get more or{' '}
                <a
                  href={PATH_DASHBOARD.SUBSCRIPTION}
                  className="underline"
                  target="_self"
                  rel="noopener noreferrer"
                >
                  <i>
                    <b>upgrade</b>
                  </i>
                </a>{' '}
                your subscription.
              </>
            }
          />
        )}
        {isTrialPlan && isInactivePlan && (
          <Banner
            text={
              <>
                Your 14-day trial is over. Fill out{' '}
                <a
                  target="_blank"
                  href={COSSUPORT_DEMO_PAGE}
                  className="underline"
                  rel="noopener noreferrer"
                >
                  <i>
                    <b>this form</b>
                  </i>
                </a>{' '}
                to extend the trial or{' '}
                <a
                  href={PATH_DASHBOARD.SUBSCRIPTION}
                  className="underline"
                  target="_self"
                  rel="noopener noreferrer"
                >
                  <i>
                    <b>upgrade</b>
                  </i>
                </a>{' '}
                your subscription.
              </>
            }
          />
        )}
        {!isTrialPlan && isInactivePlan && (
          <Banner
            type="warning"
            text={
              <>
                No active subscription. Some features are currently disabled. You can upgrade{' '}
                <a
                  href={PATH_DASHBOARD.SUBSCRIPTION}
                  className="underline"
                  target={'_self'}
                  rel="noopener noreferrer"
                >
                  here.
                </a>
              </>
            }
          />
        )}
        {userInfo && !userInfo.is_active && (
          <Banner
            type="info"
            className={'!py-2'}
            text={
              <span className={'flex flex-row gap-[5px] items-center justify-center'}>
                <span>
                  Verify your email address to unlock your full trial potential. Can’t find the
                  email? Check your spam folder.
                </span>
                <ResendVerificationEmailButton />
              </span>
            }
          />
        )}
        {isTrialPlan && isPlanRequestLimit && storageTrialLimitOpen && <LimitReachedPopup />}
      </div>
    )
  );
}
